import { Card, Flex, Skeleton, Tag, Typography } from "antd";
import { useGetQuizQuery } from "../../../../app/features/adminContent/adminContent.api";
import CheckIcon from "../../../../assets/icons/CheckIcon";
import { cn } from "../../../../utils/global.utils";

const { Title, Text } = Typography;

type Props = {
  quizId: number;
};

export default function QuizViewer({ quizId }: Props) {
  const { data: quiz, isLoading } = useGetQuizQuery(quizId);

  if (isLoading) {
    return <Skeleton active />;
  }

  if (!quiz) {
    return <div>Quiz not found</div>;
  }

  return (
    <div className="space-y-6">
      <div className="border-b pb-4">
        <Title level={4} className="!mb-2">
          {quiz.title}
        </Title>
        <Flex gap={8}>
          <Tag color="blue">Pass Mark: {quiz.passMarkPercent}%</Tag>
          <Tag color="orange">Time: {quiz.timeLimitSec / 60} mins</Tag>
          <Tag color="purple">Total Marks: {quiz.totalMarks}</Tag>
        </Flex>
      </div>

      <div className="space-y-6">
        {quiz.QuizQuestion?.map((question, index) => (
          <Card
            key={question.id}
            size="small"
            title={`Q${index + 1}: ${question.prompt}`}
            extra={<Tag>{question.marks} Marks</Tag>}
            className="bg-gray-50"
          >
            <div className="space-y-2">
              {question.QuizOption?.map((option) => (
                <div
                  key={option.id}
                  className={cn(
                    "p-3 rounded border flex items-center justify-between",
                    option.isCorrect
                      ? "bg-green-50 border-green-200"
                      : "bg-white border-gray-200",
                  )}
                >
                  <Text>{option.text}</Text>
                  {option.isCorrect && (
                    <Flex gap={4} align="center" className="text-green-600">
                      <CheckIcon size={16} />
                      <span className="text-xs font-medium">
                        Correct Answer
                      </span>
                    </Flex>
                  )}
                </div>
              ))}
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
}
